import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import { store } from '@Redux/store'
import { Provider } from 'react-redux'
import * as serviceWorker from './serviceWorker'
import { BrowserRouter } from 'react-router-dom'
import i18n from '@Locale/index'
import { I18nextProvider } from 'react-i18next'
import { injectStore } from '@Api/Api'

injectStore(store)

ReactDOM.render(
	<React.StrictMode>
		<I18nextProvider i18n={i18n}>
			<BrowserRouter>
				<Provider store={store}>
					<App />
				</Provider>
			</BrowserRouter>
		</I18nextProvider>
	</React.StrictMode>,
	document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// react-scripts 4 no longer emits build/service-worker.js, so register() fails
// with a MIME-type error; unregister also cleans up stale workers from old deploys
serviceWorker.unregister()
